import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { ConsultationsPageHeader } from '@/components/Consultations/ConsultationsPageHeader';
import { ConsultationsTable } from '@/components/tables/ConsultationsTable';

import { getAuthData } from '../data/service/authService';

import '../assets/scss/styles.scss';

const PREFIX = 'Consultations';

const classes = {
  button: `${PREFIX}-button`,
  boxStyle: `${PREFIX}-boxStyle`,
  floatCalendar: `${PREFIX}-floatCalendar`,
  ellipsis: `${PREFIX}-ellipsis`,
  Buttonlink: `${PREFIX}-Buttonlink`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled(Box)(({ theme }) => ({
  [`& .${classes.button}`]: {
    borderRadius: 20
  },

  [`& .${classes.boxStyle}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: '32px'
  },

  [`& .${classes.floatCalendar}`]: {
    float: 'right',
    zIndex: 1,
    position: 'absolute',
    right: '30px',
    top: '40px',
    '& .calendarWrap': {
      zIndex: 1,
      position: 'absolute',
      right: '0px'
    }
  },

  [`& .${classes.ellipsis}`]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  [`& .${classes.Buttonlink}`]: {
    textDecoration: 'none',
    cursor: 'pointer',
    fontSize: '12px',
    color: theme.palette.secondary.main,
    background: 'none !important',
    border: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));

const Consultations = () => {
  const { isSuperAdmin, isNurse } = getAuthData();

  return (
    <Root>
      <ConsultationsPageHeader canExport={isSuperAdmin || isNurse} />
      <Box p={4} display="flex">
        <Box component="div" width="100%">
          <ConsultationsTable />
        </Box>
      </Box>
    </Root>
  );
};

export default Consultations;
